import React from 'react';
import Card from './Card';

const ChannelView = ({ channels, userId, activeChannelTab }) => {

  const renderChannels = () => {
    const activeChannels = activeChannelTab === 'all' ? channels : filteredChannels()
    return (
      activeChannels.map((channel) => {
        return (
          <Card
            channel={channel}
            key={channel.id}
            userId={userId}/>
        );
      })
    )
  }

  const filteredChannels = () => {
    var showCommercialChannelsOnly = activeChannelTab === 'Channel::CommercialChannel';

    return channels.filter(function(channel) {
      var isChannelCommercial = channel.type === 'Channel::CommercialChannel';
      return showCommercialChannelsOnly === isChannelCommercial;
    });
  }

  return (
    <div className='all-channels-grid'>
      {renderChannels()}
    </div>
  );
};

export default ChannelView;
